import useSWR from 'swr';
import useUser from './useUser';
import {useRouteLoaderData} from 'react-router-dom';
import fetcherWithToken from '../helpers/fetcherWithToken';

const API_ROUTE =
  'https://admin.ethicssocioeconomics.com/api/1.0/companies';

function useCompanies(options = {}) {
  const {userSession} = useRouteLoaderData('root') || {};
  const {user} = useUser();
  const {data, error, isLoading, mutate, isValidating} = useSWR(
    () => (user.id ? [API_ROUTE, userSession?.accessToken?.jwtToken] : null),
    ([url, token]) => fetcherWithToken(url, token),
    options
  );

  return {
    companies: data?.companies,
    isLoading,
    isError: error,
    mutate,
    isValidating,
  };
}

export default useCompanies;
